export function calculateMonthlyGhanaPAYE(annualIncome: number): number {
    let tax = 0;

    const slabs = [
        { limit: 4824, rate: 0 },
        { limit: 6144, rate: 0.05 },     // 4824 + 1320
        { limit: 7704, rate: 0.10 },     // 6144 + 1560
        { limit: 45504, rate: 0.175 },   // 7704 + 37800
        { limit: 242184, rate: 0.25 },   // 45504 + 196680
        { limit: Infinity, rate: 0.30 }
    ];

    let remainingIncome = annualIncome;
    let previousLimit = 0;

    for (const slab of slabs) {
        const taxableAmount = Math.min(remainingIncome, slab.limit - previousLimit);
        if (taxableAmount <= 0) break;
        tax += taxableAmount * slab.rate;
        remainingIncome -= taxableAmount;
        previousLimit = slab.limit;
    }

    return Math.round(tax / 12); 
}
